import React, { useState, useMemo } from 'react';
import { ConditionalLogicModeProps } from '../ConditionalLogic';
import { SearchInput } from '../../../../../../../common/components/SearchInput/SearchInput';
import Button from '../../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';

export const ConditionalLogicTags = (props: ConditionalLogicModeProps) => {
  const { setEditMode, conditionalTags, tags, editWidget, setEditWidget } =
    props;

  const [searchText, setSearchText] = useState('');
  const unusedTags = useMemo(
    () =>
      tags.filter(
        t =>
          !conditionalTags.find(ct => t.name === ct.tagName) &&
          (!searchText || (t.name && t.name.indexOf(searchText) >= 0)),
      ),
    [searchText, tags, conditionalTags],
  );

  const onRemoveTag = (tagName: string) => {
    setEditWidget({
      ...editWidget,
      conditionalTags: conditionalTags.filter(t => t.tagName !== tagName),
    });
  };

  const onAddTag = (tagName?: string) => {
    if (!tagName) return;
    setEditWidget({
      ...editWidget,
      conditionalTags: [...conditionalTags, { tagName }],
    });
  };

  return (
    <div className="widget-conditional-logic__sub-section">
      <div className="widget-conditional-logic__header-text">
        <Button
          text
          className="widget-conditional-logic__back-button"
          onClick={() => setEditMode('root')}
        >
          <i className="fas fa-chevron-left" />
        </Button>
        Tags
      </div>
      <div className="widget-conditional-logic__instructions">
        Applied tags:
      </div>
      <div className="widget-conditional-logic__item-content">
        {conditionalTags.length === 0
          ? 'No tags chosen'
          : conditionalTags.map((t, i) => (
              <>
                {i > 0 && (
                  <div className="widget-conditional-logic__item-content-item-separator">
                    OR
                  </div>
                )}
                <div
                  key={t.tagName}
                  className="widget-conditional-logic__item-content-item"
                >
                  {t.tagName}
                  <Button
                    className="widget-conditional-logic__item-content-item-action-button"
                    text
                    onClick={() => onRemoveTag(t.tagName)}
                  >
                    <i className="fas fa-times" />
                  </Button>
                </div>
              </>
            ))}
      </div>
      <div className="widget-conditional-logic__item-content">
        <SearchInput
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          placeholder="Search tags"
        />
      </div>
      <div className="widget-conditional-logic__item-content">
        {unusedTags.length === 0
          ? 'No tags available'
          : unusedTags.map(t => (
              <Button
                text
                key={t.name}
                className={
                  'widget-conditional-logic__item-content-item ' +
                  'widget-conditional-logic__item-content-item--eligible'
                }
                onClick={() => onAddTag(t.name)}
              >
                {t.name}
                <div className="widget-conditional-logic__item-content-item-action-button">
                  <i className="fas fa-plus" />
                </div>
              </Button>
            ))}
      </div>
      <PrimaryButton
        className="widget-conditional-logic__add-button"
        onClick={() => setEditMode('root')}
      >
        Done
      </PrimaryButton>
    </div>
  );
};
